import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import {
  MouldingDownstreamExecution,
  MouldingNodeRun,
} from '../../../models/moulding-item.model';
import { RealtimeSocketService } from '../../services/realtime/realtime-socket.service';

export type MouldingFlowSocketEvent =
  | { type: 'node_run'; nodeRun: MouldingNodeRun }
  | {
      type: 'downstream_execution';
      downstreamExecution: MouldingDownstreamExecution;
    };

@Injectable({ providedIn: 'root' })
export class MouldingFlowSocketService {
  private readonly realtimeSocket = inject(RealtimeSocketService);

  listen(flowId: number): Observable<MouldingFlowSocketEvent> {
    return this.realtimeSocket
      .listenMany<MouldingNodeRun | MouldingDownstreamExecution>(
        `/ws/moulding-flow/${flowId}`,
        [
          {
            eventType: 'moulding.node_run',
            payloadKey: 'node_run',
            schema: MouldingNodeRun,
          },
          {
            eventType: 'moulding.downstream_execution',
            payloadKey: 'downstream_execution',
            schema: MouldingDownstreamExecution,
          },
        ],
      )
      .pipe(
        map((event): MouldingFlowSocketEvent => {
          if (event.eventType === 'moulding.node_run') {
            return {
              type: 'node_run',
              nodeRun: event.payload as MouldingNodeRun,
            };
          }
          return {
            type: 'downstream_execution',
            downstreamExecution: event.payload as MouldingDownstreamExecution,
          };
        }),
      );
  }
}
